(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-text"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__nevieraReadMore) return;
    window.__nevieraReadMore = true;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.addEventListener('change', (event) => {
      const chk = event.target;
      if (!(chk instanceof HTMLInputElement) || !chk.classList.contains('product-description-read-more__chk')) return;

      const root = chk.closest('.product-description-read-more');
      const clip = root?.querySelector('.product-description-read-more__clip');
      if (!root || !clip || reduceMotion.matches) return;

      const expanding = chk.checked;
      root.classList.add('is-measuring');

      // Start height: mid-animation size, or the previous state's settled size.
      let from;
      if (root.classList.contains('is-animating')) {
        from = clip.getBoundingClientRect().height;
      } else {
        chk.checked = !expanding;
        from = clip.getBoundingClientRect().height;
        chk.checked = expanding;
      }

      // End height: the new state's settled size (clamped when collapsing, full when expanding).
      root.classList.remove('is-animating');
      clip.style.height = '';
      const to = clip.getBoundingClientRect().height;

      if (Math.abs(to - from) < 1) {
        root.classList.remove('is-measuring');
        return;
      }

      root.classList.add('is-animating');
      clip.style.height = `${from}px`;
      clip.getBoundingClientRect();
      root.classList.remove('is-measuring');
      clip.style.height = `${to}px`;

      const finish = (e) => {
        if (e && (e.target !== clip || e.propertyName !== 'height')) return;
        clip.removeEventListener('transitionend', finish);
        clearTimeout(clip.__readMoreTimer);
        root.classList.remove('is-animating');
        clip.style.height = '';
      };

      if (clip.__readMoreFinish) clip.removeEventListener('transitionend', clip.__readMoreFinish);
      clearTimeout(clip.__readMoreTimer);
      clip.__readMoreFinish = finish;
      clip.addEventListener('transitionend', finish);
      // transitionend is not guaranteed (interrupted / skipped frames): fall back to the computed duration.
      const durationMs = Math.max(
        ...getComputedStyle(clip)
          .transitionDuration.split(',')
          .map((d) => parseFloat(d) * (d.trim().endsWith('ms') ? 1 : 1000) || 0)
      );
      clip.__readMoreTimer = setTimeout(finish, durationMs + 50);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
